import { useQuery } from '@tanstack/react-query'
import { useEffect, useState, useMemo } from 'react'
import { useFormikContext } from 'formik'
import requests from 'service/api'
import useTemNewStore from 'store/client/temNewStore'
import SearchSelect from '../search-select'
import { useParams } from 'react-router-dom'

export function SelectBodyChartHome({ name }) {
  const { values } = useFormikContext()
  const [selected, setSelected] = useState(null)
  const { dept } = useParams()
  const setSpecialValue = useTemNewStore((state) => state.setSpecialValue)
  const setAnotherValue = useTemNewStore((state) => state.setAnotherValue)
  const tabvalue = useTemNewStore((state) => state.tabvalue)

  const { data, isFetched } = useQuery({
    queryKey: ['/list', 'sizeGroup'],
    queryFn: async () => {
      const { data } = await requests.size.listGroupHome('')
      return data
    },
    placeholderData: []
  })

  const options = useMemo(() => data?.map(({ name, id }) => ({
    value: id,
    label: name
  })) || [], [data]);

  // Seçilen değeri takip et
  useEffect(() => {
    if (values.sizeGroup && isFetched) {
      const select = options.find(({ value }) => value === values.sizeGroup)
      setSelected(select);
    }
  }, [values.sizeGroup, isFetched, options]);

  // Tab değişikliklerini ve seçim değişikliklerini takip et
  useEffect(() => {
    if (!selected) return;

    switch (tabvalue) {
      case "0":
        setSpecialValue(selected.value);
        break;
      case "2":
      case "3":
      case "4":
        setAnotherValue(selected.value);
        break;
      default:
        break;
    }
  }, [selected, tabvalue, setSpecialValue, setAnotherValue]);

  return (
    <SearchSelect
      label="Beden Tablosu"
      options={options}
      name={name}
      value={selected}
      onChange={(e) => setSelected(e)}
    />
  )
}
